import React from 'react';

import { createPortal } from 'react-dom';

// import classes from './Spinner.css';
import './Spinner.css';
const spinner = () =>
  createPortal(
    <div className="loader-container">
      <div className="Loader">Loading...</div>
    </div>,
    document.getElementById('backdrop-root'),
  );

export default spinner;
